import { getNumberProperties } from './getNumberProperties';
/**
 * Returns the xLogP3 of a compound
 *
 * @param data Data of a compound data request to the PubChem API
 * @returns Computed Data
 */
export function getxLogP3(data) {
    const xLogP3 = getNumberProperties(data, 'XLogP3');
    return xLogP3;
}
//# sourceMappingURL=getxLogP3.js.map